import '../styles/ProductPage.css';

const StepNavigation = ({ currentStep, setStep, maxStepReached }) => {
  const steps = ['1', '2', '3', '4', '5', '6', '7'];

  return (
    <div className="step-nav">
      {steps.map((label, index) => {
        const isActive = index === currentStep;
        const isClickable = index <= maxStepReached;

        return (
          <button
            key={index}
            className={isActive ? 'active' : 'inactive'}
            onClick={() => {
              if (isClickable) setStep(index);
            }}
            disabled={!isClickable}
            style={{
              cursor: isClickable ? 'pointer' : 'not-allowed',
              opacity: isClickable ? 1 : 0.5
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};


export default StepNavigation;
